export const REDUX_STORE_HOME = 'add_topic_source'
export const SOURCE_NAME = 'Topic'
